export const DEVELOPMENT = 'development';
export const HYMNS = 'hymns';
export const COMPOSERS = 'composers';
export const AUTHORS = 'authors';
export const TUNES = 'tunes';
